module.exports = __webpack_public_path__ + "img/product_84.4ae9739.webp";